import { render } from "./HomeStartViewSlider.vue?vue&type=template&id=bc3c6aaa"
import script from "./HomeStartViewSlider.vue?vue&type=script&lang=js"
export * from "./HomeStartViewSlider.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__